/** @jsx jsx */
import React, { FC, Fragment } from "react";
import { jsx } from "@emotion/react";
import { noop } from "lodash/fp";
import { SelectedRowKeys } from "src/components/organisms/TemplateView/fragments/TemplateTable/types";
import { TableDataDesktop } from "../../../organisms/TableData";
import { TableRow, TableColumns } from "../../../../requests/table/types";
import { DesktopOnly, NoDesktop } from "../../../atoms/ViewportRestrictor";
import TableDataMobile from "../../../organisms/TableData/TableDataMobile";
import { MobileRowLayout } from "../../../organisms/ColumnTemplatePositionEditor/types";
import { mobileRowPositionDataPLACEHOLDER } from "../../../organisms/ColumnTemplatePositionEditor/placeholderData";
import { ColumnFormatDict } from "../../../../requests/templates/types";
import {
  Order,
  OrderValue,
  StringIndexedDictionary,
} from "../../../../globalTypes";
import { EditRowWithColumns } from "../../../../requests/tableRowActions/types";

interface RelationTableProps {
  rows: TableRow[];
  columns: TableColumns;
  onSelectCallback?: (row: EditRowWithColumns) => void;
  columnFormatDict: ColumnFormatDict;
  columnFormatMobileDict: ColumnFormatDict;
  columnOrderByColumnName: StringIndexedDictionary<number>;
  positionData?: MobileRowLayout | null;
  order: Order;
  onOrder: (colKey: string, newOrder: OrderValue) => void;
  loadMoreMobile: () => void;
  isLoadingMoreMobile: boolean;
  totalRowCount: number;
  keysOfSelectedRows?: SelectedRowKeys;
}

const RelationTable: FC<RelationTableProps> = ({
  rows,
  columns,
  onSelectCallback,
  columnFormatDict,
  loadMoreMobile = noop,
  isLoadingMoreMobile = false,
  columnFormatMobileDict,
  positionData,
  totalRowCount,
  columnOrderByColumnName,
  keysOfSelectedRows,
  onOrder,
  order,
}) => (
  <Fragment>
    <DesktopOnly>
      <TableDataDesktop
        columnOrderByColumnName={columnOrderByColumnName}
        editedColumnOrderByColumnName={columnOrderByColumnName}
        rows={rows}
        columns={columns}
        allowRowClick
        onRowClickCallback={onSelectCallback}
        columnFormatDict={columnFormatDict}
        order={order}
        onOrder={onOrder}
        allowRowSelection={Boolean(keysOfSelectedRows)}
        keysOfSelectedRows={keysOfSelectedRows}
      />
    </DesktopOnly>

    <NoDesktop>
      <TableDataMobile
        isFromRelationTable
        rows={rows}
        columns={columns}
        allowRowSelection
        keysOfSelectedRows={keysOfSelectedRows}
        onMobileRowClick={onSelectCallback}
        totalRowCount={totalRowCount}
        columnFormatMobileDict={columnFormatMobileDict}
        positionData={positionData || mobileRowPositionDataPLACEHOLDER}
        loadMoreDataMobile={loadMoreMobile}
        isLoadingMoreMobile={isLoadingMoreMobile}
      />
    </NoDesktop>
  </Fragment>
);

export default RelationTable;
